import React, { Component } from 'react';

import Proceso from './Proceso';

class ContenedorProcesos extends Component {

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    esFechaActual(fecha) {
        let fechaActual;

        if (fecha == new Date().toLocaleDateString('en-GB'))
            fechaActual = true;
        else
            fechaActual = false;

        return fechaActual;
    }

    crearMensajeProcesos(fechaActual, procesosProgramados, administradoraId) {
        /* Mensajes a mostrar según fecha y cantidad de procesos*/
        let msjCalendarioSinProcesos = "No se encuentran procesos ejecutados o a ejecutar para la fecha seleccionada.";
        let msjSinProcesos = "No se ha ejecutado ningún proceso de los programados para la fecha seleccionada.";
        let msjSinProcesosFechaActual = "Aún no se ha ejecutado ningún proceso de los programados para la fecha seleccionada.";
        let msjParaMostrar = "";

        let proceso = procesosProgramados?.find(p => p.IdAdministradora == administradoraId);

        if (proceso?.IdAdministradora) {
            if (fechaActual) {
                if (proceso?.Cantidad_Calendario > 0)
                    msjParaMostrar = proceso?.Cantidad_Proceso_Diario > 0 ? "" : msjSinProcesosFechaActual;
                else
                    msjParaMostrar = msjSinProcesosFechaActual;
            } else {
                if (proceso?.Cantidad_Calendario > 0)
                    msjParaMostrar = proceso?.Cantidad_Proceso_Diario > 0 ? "" : msjSinProcesos;
                else
                    msjParaMostrar = msjCalendarioSinProcesos;
            }
        } else {
            //Procesos sin AdministradoraId - Procesos "Genéricos"
            //Por defecto para procesos sin AdministradoraId el valor Cantidad_Calendario es siempre "0"
            if (fechaActual) {
                msjParaMostrar = proceso?.Cantidad_Proceso_Diario > 0 ? "" : msjSinProcesosFechaActual;
            }
            else {
                msjParaMostrar = proceso?.Cantidad_Proceso_Diario > 0 ? "" : msjCalendarioSinProcesos;
            }
        }

        return msjParaMostrar;
    }

    render() {

        const { administradora, procesos, variasMarcas, procesosProgramados, fecha } = this.props;

        let logo = "";
        let textoTooltipAgenda = 'Haga click para visualizar los procesos de la Marca documentados para ser ejecutados en la fecha.';

        let msjParaMostrar = "";

        switch (administradora) {
            case 1:
                logo = " image-visa-logo procesoLogo"
                msjParaMostrar = this.crearMensajeProcesos(this.esFechaActual(fecha), procesosProgramados, administradora);
                break;

            case 2:
                logo = " image-cabal-logo procesoLogo"
                msjParaMostrar = this.crearMensajeProcesos(this.esFechaActual(fecha), procesosProgramados, administradora);
                break;

            case 3:
                logo = " image-mastercard-logo procesoLogo"
                msjParaMostrar = this.crearMensajeProcesos(this.esFechaActual(fecha), procesosProgramados, administradora);
                break;

            case null:
                logo = " image-AD17-logo procesoLogo"
                msjParaMostrar = this.crearMensajeProcesos(this.esFechaActual(fecha), procesosProgramados, administradora);
                break;
        }

        return (
            <div className={variasMarcas ? 'contenedorProcesos' : 'contenedorProcesosLarge'}>
                <div className='procesoColumnRight procesoHeader'>
                    <div className='procesoColumn procesoColumnLeft'>
                        <div className={logo}></div>
                    </div>
                    <div className='procesoColumn procesoColumnRight'>
                        <div className='inicioFin'>
                            Inicio | Fin
                        </div>
                        <div className='cantidadProcesosLabel'>
                            {procesos.length + " procesos"} <div onClick={() => { this.props.mostrarModal(1, true, { marcaId: administradora }) }} className="icono-proceso" data-toggle="tooltip" data-title={textoTooltipAgenda} data-placement="right"></div>
                        </div>
                    </div>
                </div>

                <div className='inicioFin'>
                    {msjParaMostrar}
                </div>
                {procesos.map(proceso => <Proceso sumarDia={proceso.sumarDia} variasMarcas={variasMarcas} trazaId={proceso.ProcesoTrazaId} mostrarModal={this.props.mostrarModal} color={proceso.ColorResultado} horaFin={proceso.HoraFin} horaInicio={proceso.HoraInicio} nombre={proceso.DescripcionProceso} spinGear={proceso.EsTrazaReprocesada > 0} estado={proceso.ProcesoEstadoId} tipo={proceso.TipoProceso} />)}
            </div>
        );
    }
}

export default ContenedorProcesos;